const logoStyle = {
    height: "40px", 
    margin: "0 30px 0 10px"
}

export const Logo = () => {
    return (
        <img alt="question salad logo" title="question salad logo"
            src={`${process.env.PUBLIC_URL}/logo512.png`}
            style={logoStyle}
        />
    )
}